export enum ETicketPayment {
    SET_IN_PROCESS = 'SEASON_TICKET/SET_IN_PROCESS',

    SET_IS_USE_BONUSES = 'SEASON_TICKET/BONUSES/SET_IS_USE_BONUSES',
    SET_BONUSES_AMOUNT = 'SEASON_TICKET/BONUSES/SET_BONUSES_AMOUNT',
    SET_BONUSES_VALIDITY = 'SEASON_TICKET/BONUSES/SET_BONUSES_VALIDITY',
    SET_BONUSES_RESULT = 'SEASON_TICKET/BONUSES/SET_BONUSES_RESULT',

    SET_SEASON_TICKET = 'SEASON_TICKET/SET_SEASON_TICKET',
    SET_PAYMENT_SUM_IS_LOADING = 'SEASON_TICKET/SET_PAYMENT_SUM_IS_LOADING',
    SET_PAYMENT_SUM_IS_ERROR = 'SEASON_TICKET/SET_PAYMENT_SUM_IS_ERROR',

    SET_IS_FETCHING = 'SEASON_TICKET/SBP/SET_IS_FETCHING',
    SET_QR_LINK = 'SEASON_TICKET/SBP/SET_QR_LINK',
    SET_QR_CODE = 'SEASON_TICKET/SBP/SET_QR_CODE',
    SET_QR_FETCHING_RESULT = 'SEASON_TICKET/SBP/SET_QR_FETCHING_RESULT',

    SET_CONNECTION_RESULT = 'SEASON_TICKET/SET_CONNECTION_RESULT',
    SET_TICKET_POPUP_STATE = 'SEASON_TICKET/SET_TICKET_POPUP_STATE',

    RESET_STATE = 'SEASON_TICKET/RESET_STATE',
}

export enum EValidityStatus {
    IS_VALID = 'IS_VALID',
    IS_UPPER_BOUND_ERROR = 'IS_UPPER_BOUND_ERROR',
    IS_LOWER_BOUND_ERROR = 'IS_LOWER_BOUND_ERROR',
}

export type { TResetState } from './resetState';
export { default as resetState } from './resetState';
export type { TSetBonusesAmount } from './setBonusesAmount';
export { default as setBonusesAmount } from './setBonusesAmount';
export type { TSetBonusesAmountValidity } from './setBonusesAmountValidity';
export { default as setBonusesAmountValidity } from './setBonusesAmountValidity';
export type { TBonusesResult } from './setBonusesResult';
export type { TSetBonusesResult } from './setBonusesResult';
export { default as setBonusesResult } from './setBonusesResult';
export type { TConnectionResult } from './setConnectionResult';
export type { TSetConnectionResult } from './setConnectionResult';
export { default as setConnectionResult } from './setConnectionResult';
export type { TSetInProcess } from './setInProcess';
export { default as setInProcess } from './setInProcess';
export type { TSetIsFetching } from './setIsFetching';
export { default as setIsFetching } from './setIsFetching';
export type { TSetIsUseBonuses } from './setIsUseBonuses';
export { default as setIsUseBonuses } from './setIsUseBonuses';
export type { TSetPaymentSumIsError } from './setPaymentSumIsError';
export { default as setPaymentSumIsError } from './setPaymentSumIsError';
export type { TSetPaymentSumIsLoading } from './setPaymentSumIsLoading';
export { default as setPaymentSumIsLoading } from './setPaymentSumIsLoading';
export type { TSetQrCode } from './setQrCode';
export { default as setQrCode } from './setQrCode';
export type { TQrFetchingResult } from './setQrFetchingResult';
export type { TSetQrFetchingResult } from './setQrFetchingResult';
export { default as setQrFetchingResult } from './setQrFetchingResult';
export type { TSetQrLink } from './setQrLink';
export { default as setQrLink } from './setQrLink';
export type { TSetSeasonTicket } from './setSeasonTicket';
export { default as setSeasonTicket } from './setSeasonTicket';
export type { TSetTicketPopup } from './setTicketPopup';
export { default as setTicketPopup } from './setTicketPopup';
